/** Normalize a phone string to E.164-ish digits with +1 default (US) for Google Voice URLs. */
export function normalizePhone(raw) {
  if (!raw) return null;
  const digits = String(raw).replace(/[^\d+]/g, "");
  if (!digits) return null;
  if (digits.startsWith("+")) return digits;
  const only = digits.replace(/^\+/, "");
  if (only.length === 10) return "+1" + only;      // US default
  if (only.length === 11 && only.startsWith("1")) return "+" + only;
  return "+" + only;
}

export function googleVoiceCallUrl(phone) {
  const p = normalizePhone(phone);
  return p ? `https://voice.google.com/u/0/calls?a=nc,${encodeURIComponent(p)}` : null;
}

export function googleVoiceTextUrl(phone) {
  const p = normalizePhone(phone);
  return p ? `https://voice.google.com/u/0/messages?itemId=t.${encodeURIComponent(p)}` : null;
}
